module.exports = __webpack_public_path__ + "img/logo-samu.f15f9e5f.png";